(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tbc-core-beers"]) return;
  try {
    
document.querySelectorAll('[data-core-list]').forEach(function(list){Array.from(list.children).sort(function(a,b){return Number(a.dataset.coreOrder)-Number(b.dataset.coreOrder)}).forEach(function(item){list.appendChild(item)})});
document.querySelectorAll('.tbc-core').forEach(function(root){function activate(tab){root.querySelectorAll('[data-core-tab]').forEach(function(item){item.setAttribute('aria-selected',item===tab?'true':'false')});root.querySelectorAll('.tbc-core__panel').forEach(function(panel){panel.hidden=panel.id!=='tbc-'+tab.dataset.coreTab})}root.querySelectorAll('[data-core-tab]').forEach(function(tab){tab.addEventListener('click',function(){activate(tab);history.replaceState(null,'','#'+tab.dataset.coreTab)})});var initial=root.querySelector('[data-core-tab="'+location.hash.slice(1)+'"]');if(initial)activate(initial)});
if(window.IntersectionObserver&&window.matchMedia('(hover: none), (pointer: coarse)').matches){const observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){entry.target.classList.toggle('is-in-view',entry.isIntersecting&&entry.intersectionRatio>=.6)})},{threshold:[0,.6,1]});document.querySelectorAll('[data-core-secondary]').forEach(function(item){observer.observe(item)})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbc-editorial-awards"]) return;
  try {
    
document.querySelectorAll('[data-awards-filter]').forEach(function(root){
  if(root.dataset.awardsReady)return;
  root.dataset.awardsReady='true';
  var medal=root.querySelector('[data-awards-medal]');
  var beer=root.querySelector('[data-awards-beer]');
  var reset=root.querySelector('[data-awards-reset]');
  var count=root.querySelector('[data-awards-count]');
  var empty=root.querySelector('[data-awards-empty]');
  function update(){
    var visible=0;
    root.querySelectorAll('.tbc-awards__year').forEach(function(year){
      var yearVisible=0;
      year.querySelectorAll('[data-awards-card]').forEach(function(card){
        var match=(!medal.value||card.dataset.medal===medal.value)&&(!beer.value||card.dataset.beer===beer.value);
        card.hidden=!match;
        if(match){visible++;yearVisible++}
      });
      year.hidden=yearVisible===0;
    });
    count.textContent=visible+' '+(visible===1?'award':'awards');
    empty.hidden=visible!==0;
    reset.hidden=!medal.value&&!beer.value;
  }
  medal.addEventListener('change',update);
  beer.addEventListener('change',update);
  reset.addEventListener('click',function(){medal.value='';beer.value='';update()});
  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbc-editorial-story"]) return;
  try {
    
document.querySelectorAll('.tbc-story__chapters').forEach(function (container) { Array.from(container.children).sort(function (a,b) { return Number(a.dataset.editorialOrder)-Number(b.dataset.editorialOrder); }).forEach(function (item) { container.appendChild(item); }); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbc-editorial-team"]) return;
  try {
    
document.querySelectorAll('.tbc-team__grid').forEach(function (container) { Array.from(container.children).sort(function (a,b) { return Number(a.dataset.editorialOrder)-Number(b.dataset.editorialOrder); }).forEach(function (item) { container.appendChild(item); }); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbc-menu-page"]) return;
  try {
    
document.querySelectorAll('[data-tbc-menu]').forEach(function (menu) {
  menu.querySelectorAll('.tbc-menu__items').forEach(function (group) {
    var items = Array.from(group.children);
    var unplaced = items.filter(function (item) { return !item.dataset.menuOrder; });
    unplaced.sort(function (a, b) { return Number(a.dataset.menuId) - Number(b.dataset.menuId); });
    var placed = items.filter(function (item) { return item.dataset.menuOrder; });
    placed.sort(function (a, b) {
      return Number(a.dataset.menuOrder) - Number(b.dataset.menuOrder);
    });
    placed.forEach(function (item) {
      var position = Math.max(1, Math.floor(Number(item.dataset.menuOrder) || 1));
      unplaced.splice(Math.min(position - 1, unplaced.length), 0, item);
    });
    unplaced.forEach(function (item, index) {
      item.dataset.effectiveMenuOrder = String(index + 1);
      group.appendChild(item);
    });
  });
  var tabs = Array.from(menu.querySelectorAll('[data-menu-tab]'));
  var panels = Array.from(menu.querySelectorAll('[data-menu-panel]'));
  var tapTabs = Array.from(menu.querySelectorAll('[data-tap-tab]'));
  var tapPanels = Array.from(menu.querySelectorAll('[data-tap-panel]'));
  function showTaproom(key, updateHash) {
    tapTabs.forEach(function (tab) {
      var selected = tab.dataset.tapTab === key;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });
    tapPanels.forEach(function (panel) { panel.hidden = panel.dataset.tapPanel !== key; });
    menu.querySelectorAll('[data-drink-locations]').forEach(function (item) {
      item.hidden = item.dataset.drinkLocations.split(' ').indexOf(key) === -1;
    });
    if (updateHash) history.replaceState(null, '', '#menu-drinks-' + key);
  }
  function show(key, updateHash) {
    tabs.forEach(function (tab) {
      var selected = tab.dataset.menuTab === key;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });
    panels.forEach(function (panel) { panel.hidden = panel.dataset.menuPanel !== key; });
    if (updateHash) history.replaceState(null, '', '#menu-' + key);
    if (updateHash) {
      var activePanel = panels.find(function (panel) { return panel.dataset.menuPanel === key; });
      if (activePanel) activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  tabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () { show(tab.dataset.menuTab, true); });
    tab.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var next = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      tabs[next].focus();
      show(tabs[next].dataset.menuTab, true);
    });
  });
  tapTabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () { showTaproom(tab.dataset.tapTab, true); });
    tab.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var next = (index + (event.key === 'ArrowRight' ? 1 : -1) + tapTabs.length) % tapTabs.length;
      tapTabs[next].focus();
      showTaproom(tapTabs[next].dataset.tapTab, true);
    });
  });
  menu.querySelectorAll('[data-menu-category-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var target = document.getElementById(select.value);
      if (!target) return;
      history.replaceState(null, '', '#' + select.value);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  var hash = decodeURIComponent(location.hash);
  var match = tabs.find(function (tab) { return hash === '#menu-' + tab.dataset.menuTab || hash.indexOf('#menu-' + tab.dataset.menuTab + '-') === 0; });
  if (match) show(match.dataset.menuTab, false);
  var tapMatch = tapTabs.find(function (tab) { return hash === '#menu-drinks-' + tab.dataset.tapTab || hash.indexOf('#menu-drinks-' + tab.dataset.tapTab + '-') === 0; });
  showTaproom(tapMatch ? tapMatch.dataset.tapTab : 'movie-towne', false);
});

  } catch(e) { console.error(e); }
})();
})();
